import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createCustomerGroup } from '../../../common/api/clients/customerGroups.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useCustomerGroupCreate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createCustomerGroup,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queries.customerGroups._def }),
    });
};
